export type RocketStandardSlide = {
  id: string
  number: number
  group: string
  title: string
  image: string
}

/** Páginas da apresentação comercial Rocket Search, na ordem do deck enviado. */
export const ROCKET_STANDARD_SLIDES: RocketStandardSlide[] = [
  { id: 'capa', number: 1, group: 'Abertura', title: 'Capa', image: '/rocket-presentation/page-01.jpg' },
  { id: 'alem-da-busca', number: 2, group: 'Plataforma', title: 'Muito além de uma busca', image: '/rocket-presentation/page-02.jpg' },
  { id: 'integracao-api', number: 3, group: 'Plataforma', title: 'Integração via API', image: '/rocket-presentation/page-03.jpg' },
  { id: 'busca-simples', number: 4, group: 'Busca', title: 'Muito além da busca simples', image: '/rocket-presentation/page-04.jpg' },
  { id: 'maior-vendedor', number: 5, group: 'Busca', title: 'O maior vendedor é a busca', image: '/rocket-presentation/page-05.jpg' },
  { id: 'busca-inteligente', number: 6, group: 'Busca', title: 'Busca inteligente', image: '/rocket-presentation/page-06.jpg' },
  { id: 'funil', number: 7, group: 'Busca', title: 'Buscas em cada etapa do funil', image: '/rocket-presentation/page-07.jpg' },
  { id: 'ia', number: 8, group: 'Inteligência', title: 'IA aplicada ao e-commerce', image: '/rocket-presentation/page-08.jpg' },
  { id: 'encontre-mais', number: 9, group: 'Inteligência', title: 'Encontre mais. Venda mais.', image: '/rocket-presentation/page-09.jpg' },
  { id: 'vitrines', number: 10, group: 'Vitrines', title: 'Vitrines inteligentes', image: '/rocket-presentation/page-10.jpg' },
  { id: 'teste-ab', number: 11, group: 'Vitrines', title: 'Teste A/B de vitrines', image: '/rocket-presentation/page-11.jpg' },
  { id: 'regionalizacao', number: 12, group: 'Vitrines', title: 'Regionalização inteligente', image: '/rocket-presentation/page-12.jpg' },
  { id: 'avaliacoes', number: 13, group: 'Resultados', title: 'Avaliações e conversão', image: '/rocket-presentation/page-13.jpg' },
  { id: 'analytics', number: 14, group: 'Resultados', title: 'Resultados à mão', image: '/rocket-presentation/page-14.jpg' },
  { id: 'fechamento', number: 15, group: 'Fechamento', title: 'Acelere, ou fique para trás', image: '/rocket-presentation/page-15.jpg' },
]

/** Arte em alta, extraída do PowerPoint. A galeria do estúdio continua nos thumbs leves. */
export function rocketPresentationImage(number: number): string {
  return `/rocket-presentation/hd/page-${String(number).padStart(2, '0')}.png`
}

export function rocketStandardSlideGroups(slides: RocketStandardSlide[] = ROCKET_STANDARD_SLIDES) {
  const groups: { group: string; slides: RocketStandardSlide[] }[] = []
  for (const slide of slides) {
    const current = groups[groups.length - 1]
    if (!current || current.group !== slide.group) groups.push({ group: slide.group, slides: [slide] })
    else current.slides.push(slide)
  }
  return groups
}
